import {Language} from '../components/navigation-bar/language-switcher/types/language-switcher.types';

export class User {
  id: number;
  email: string;
  login: string;
  password: string;
  firstName: string;
  lastName: string;
  imageUrl: string;
  activated: boolean;
  createdBy: string;
  createdDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  langKey: Language;
  authorities: Authority[];

  constructor(
    id: number,
    email = '',
    login = '',
    password = '',
    firstName = '',
    lastName = '',
    imageUrl = '',
    activated = false,
    createdBy = '',
    createdDate = new Date(),
    lastModifiedBy = '',
    lastModifiedDate = new Date(),
    langKey = Language.EN,
    authorities = [Authority.USER],
  ) {
    this.id = id;
    this.email = email;
    this.login = login;
    this.password = password;
    this.firstName = firstName;
    this.lastName = lastName;
    this.imageUrl = imageUrl;
    this.activated = activated;
    this.createdBy = createdBy;
    this.createdDate = createdDate;
    this.lastModifiedBy = lastModifiedBy;
    this.lastModifiedDate = lastModifiedDate;
    this.langKey = langKey;
    this.authorities = authorities;
  }
}

export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  CREATOR = 'ROLE_CREATOR',
  USER = 'ROLE_USER'
}
